import React from 'react';
import { Box, Container, Grid2 as Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

import PostBreadcrumbs from '../../Components/Posts/Breadcrumbs';
import Hidden from '../../Components/DesignSystem/Hidden';
import ShareIt from '../../Components/Posts/Shared/ShareIt';
import SubNavBar from '../../Components/SubNavBar';
import { PostCategories } from '../../Utils/Types';
import PostHeader from '../PostHeader';
import { Post } from '../../Utils/Types/Posts';
import useSpace from '../../Hooks/useSpace';

const PostSideContent = styled('div')(({ theme: { mixins, spacing } }: any) => ({
  position: 'sticky',
  top: `calc(${spacing(4)} + ${mixins.toolbar['@media (min-width:600px)'].minHeight * 2}px)`,
  willChange: 'transform', // render the sticky part in its own composite layer for performance
  marginBottom: spacing(1),
}));

interface PostLayoutProps {
  post: Post;
  postMainContent: any;
  postSideContent?: any;
  stickyFooterButton?: any;
}

function PostLayout({
  post,
  postMainContent,
  postSideContent = null,
  stickyFooterButton = null,
}: PostLayoutProps) {
  const { space } = useSpace();
  const isMessaging = PostCategories.MESSAGING.includes(post.type);

  const { title, id, type } = post;

  return (
    <SubNavBar
      navbar={
        <Container maxWidth="lg">
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <PostBreadcrumbs post={post} />
            </Box>

            {!isMessaging && (
              <Box>
                <ShareIt postId={id} postTitle={title} postType={type} />
              </Box>
            )}
          </Box>
        </Container>
      }
    >
      <PostHeader post={post} space={space} />

      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 9 }}>{postMainContent}</Grid>
          <Hidden breakpoint="md" direction="down">
            <Grid size={3}>
              <PostSideContent>{postSideContent}</PostSideContent>
            </Grid>
          </Hidden>
        </Grid>

        {stickyFooterButton}
      </Container>
    </SubNavBar>
  );
}

export default PostLayout;
